import React, { useMemo } from "react";
import { Polygon } from "react-leaflet";
import { seedShapePoints } from "features/Responder/features/Zones";

export default function ZonePlacementPreview({ latlng, shape = "square", sizeMeters = 60 }) {
  const points = useMemo(() => {
    if (!latlng) return null;
    return seedShapePoints(latlng, shape, sizeMeters);
  }, [latlng, shape, sizeMeters]);

  if (!points || !points.length) return null;

  return (
    <Polygon
      positions={points.map((p) => [p.lat, p.lng])}
      pathOptions={{
        color: "#f97316",
        weight: 2,
        dashArray: "6 4",
        fillColor: "#f97316",
        fillOpacity: 0.15,
      }}
      interactive={false}
    />
  );
}


